import moment from "moment";

const getHashCode = (str) => {
  var hash = 0,
    i,
    chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

const capitalize = (str) => {
  return `${str[0].toUpperCase()}${str.slice(1)}`;
};

const getReportTitle = (report) => {
  const reportDate = moment(report.date).format("LL");
  return `${capitalize(report.reportType)} Report for ${reportDate}`;
};

const getFirstName = (name) => {
  if (!name) {
    return null;
  }
  const nameTokens = name.split(" ");
  return nameTokens && nameTokens.length > 0 ? nameTokens[0] : name;
};

const getLastName = (name) => {
  if (!name) {
    return null;
  }
  const nameTokens = name.split(" ");
  return nameTokens && nameTokens.length > 1
    ? nameTokens[nameTokens.length - 1]
    : null;
};

export { capitalize, getReportTitle, getHashCode, getFirstName, getLastName };
